import { Component, Input, OnChanges, OnInit, ViewEncapsulation, HostBinding, SimpleChanges, Inject, PLATFORM_ID } from '@angular/core';
import { MediaPictureOptions } from '../../model/MediaPictureOptions';
import { MediaPictureService } from '../../services/media-picture.service';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { ScreenType } from 'projects/common/model/ScreenType';
import { isPlatformBrowser } from '@angular/common';
import { ModuleService } from 'projects/common/services/module.service';
import { HeaderWrapperComponent } from '../header-wrapper/header-wrapper.component';

export interface BackgroundData {
  first_color: string;
  second_color: string;
  direction: string;
  opacity: string;
  picture: string;
  picture_mobile: string;
  position: string;
  css_options?: {[key: string]: string};
  inverted_background?: boolean;
  alt?: string;
}

@Component({
  selector: 'background-header',
  template: `
    <img *ngIf="src" [src]="src + imageSize" [alt]="data.alt" [style.object-position]="data.position" [style]="cssOptions">
  `,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./background.component.scss']
})
export class BackgroundHeaderComponent implements OnInit, OnChanges {
  @Input() data: BackgroundData;
  @Input() options: MediaPictureOptions;

  screenType: ScreenType;
  src?: string;
  cssOptions: {[key: string]: string | undefined} = {};

  desktopImageSize: string = '1900x500';
  mobileImageSize: string = '400x250';
  imageSize: string = ''

  @HostBinding('style.background-color') backgroundColor: string;

  constructor(private landingModelService: LandingModelService,
    private mediaPictureService: MediaPictureService,
    private moduleService: ModuleService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.screenType = this.landingModelService.getLandingModel().device.type;
  }

  ngOnInit(): void {
    this.initialize();

    if (this.moduleService.isRestrictResources(HeaderWrapperComponent.MODULE_ID)) {
      this.imageSize = '/' + (this.screenType == 'MOBILE' ? this.mobileImageSize : this.desktopImageSize);
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    if (isPlatformBrowser(this.platformId)) {
      if (changes.data?.currentValue) {
        this.initialize();
      }
    }
  }

  initialize() {
    this.src = this.getSrc();
    if (this.data.first_color) {
      this.backgroundColor = this.data.first_color;
    }
    this.cssOptions = this.data.css_options || {};
  }

  getSrc() {
    const mediaUrl = this.screenType === 'MOBILE' && this.data.picture_mobile ? this.data.picture_mobile : this.data.picture;
    return mediaUrl ? `${(this.mediaPictureService.getMediaUrl(mediaUrl))}` : undefined;
  }
}
